import * as React from 'react';
import { currentSearchPivotKey } from '../selectors/searchViewSelectors';
import { initializeSearchFilters } from '../mutators/searchViewMutators';
import { lazyIsSearchBoxEmpty } from 'owa-search';
import { startSearch } from 'owa-search-actions';
import { SearchScenarioId } from 'owa-search-store';

export default function useSearchRefinersState() {
    const [refinersVisible, setRefinersVisible] = React.useState<boolean>(false);
    const searchPivotKey = currentSearchPivotKey();

    const onFilterButtonClicked = React.useCallback(
        (evt: React.MouseEvent<HTMLButtonElement>) => {
            evt.stopPropagation();
            setRefinersVisible(!refinersVisible);
        },
        [refinersVisible]
    );
    const onSearchButtonClicked = React.useCallback(
        async (evt: React.MouseEvent<HTMLButtonElement>) => {
            evt.stopPropagation();
            const isSearchBoxEmpty = await lazyIsSearchBoxEmpty.import();
            if (!isSearchBoxEmpty(SearchScenarioId.Spaces)) {
                startSearch(
                    'SearchScopeRefiner',
                    SearchScenarioId.Spaces,
                    true /* explicitSearch */
                );
            }
            setRefinersVisible(false);
        },
        []
    );
    const onClearFiltersButtonClicked = React.useCallback(
        (evt: React.MouseEvent<HTMLButtonElement>) => {
            evt.stopPropagation();
            initializeSearchFilters();
        },
        []
    );

    const refinersButton = React.useRef(null);

    React.useEffect(() => {
        initializeSearchFilters();
    }, [searchPivotKey]);

    return {
        refinersVisible: refinersVisible,
        onFilterButtonClicked: onFilterButtonClicked,
        onSearchButtonClicked: onSearchButtonClicked,
        onClearFiltersButtonClicked: onClearFiltersButtonClicked,
        refinersButton: refinersButton,
    };
}
